import React, { useEffect, useState } from 'react';
import { Tabs, Select } from 'antd';
import { Feed } from 'semantic-ui-react';
import Chat from '../../Components/Comments/Chat';
import { useParams } from 'react-router-dom';
import { getDataDoc } from '../../database';
import './Class.css';
import './ClassModern.css';
import { useSelector } from 'react-redux';
import { db } from '../../database/firebase';
import Lectii from './Lectii';
import ModalSettingsClass from './ModalSettingsClass';
import { RetriveImageUrl } from '../../utils';
import { useDispatch } from 'react-redux';
import { Spin } from 'antd';
import OrarClasa from '../../Components/OrarClasa';
import { testSlice } from '../../redux/store';
import { useNavigate } from 'react-router-dom';
import { doc, onSnapshot } from 'firebase/firestore';
import CatalogComponent from '../../Components/Catalog';
import Teme from './Teme';
import { SettingOutlined, StarOutlined } from '@ant-design/icons';
import withErrorBoundary from '../../Components/withErrorComponent';
import DateElevi from '../../Components/DateElevi';
const { actions } = testSlice;
const { GET_LOADING } = actions;

function Class() {
  const classId = useParams().id;
  const [classData, setClassData] = useState(null);
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const settings = useSelector((state) => state.settings);
  const profesori = useSelector((state) => state.profesori);
  const navigate = useNavigate();
  const [modul, setModul] = useState(
    (settings?.module || []).find((mod) => mod.open === true)?.modul
  );
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [tabKey, setTabKey] = useState('Catalog');
  const [permision, setPermision] = useState(false);

  const onChange = (key) => {
    setTabKey(key);
  };
  const getData = async () => {
    setLoading(true);
    let dataClass = await getDataDoc('claseData', classId);

    let perm = false;
    if (
      user.uid === dataClass?.diriginte ||
      user.type === 'admin' ||
      user.uid === dataClass?.diriginte_step
    )
      perm = true;
    if (
      user.uid &&
      !dataClass?.materii?.find((m) =>
        m.profesori?.find((p) => p === user.uid)
      ) &&
      !(
        dataClass.diriginte == user.uid || dataClass.diriginte_step !== user.uid
      ) &&
      user.type !== 'admin'
    )
      navigate('/');
    if (perm === true)
      setClassData({
        ...dataClass,
        ore: (dataClass?.ore || []).map((el) => {
          return {
            ...el,
            startDate: new Date(el.startDate),
            endDate: new Date(el.endDate),
          };
        }),
      });
    else
      setClassData({
        ...dataClass,
        ore: (dataClass?.ore || []).map((el) => {
          return {
            ...el,
            startDate: new Date(el.startDate),
            endDate: new Date(el.endDate),
          };
        }),
        materii: dataClass?.materii?.filter(
          (ma) =>
            ma?.profesori?.find((p) => p === user.id) ||
            (settings?.showPurtare === true &&
              ma?.materie?.toLowerCase().includes('purtare'))
        ),
      });

    setPermision(perm);
    setLoading(false);
  };

  useEffect(() => {
    getData();
    const unsub = onSnapshot(doc(db, 'claseData', classId), (doc) => {
      getData();
    });
    return () => unsub();
  }, [classId, user]);

  console.log({ classData });
  return (
    <div className='class-page'>
      {loading ? (
        <div className='class-loading'>
          <Spin tip='Se încarcă...' size='large' spinning={loading} />
          <div className='class-loading-text'>
            Pregătim informațiile clasei...
          </div>
        </div>
      ) : (
        <>
          <ModalSettingsClass
            open={open}
            setOpen={setOpen}
            clasa={classData}
            confirmLoading={confirmLoading}
            setConfirmLoading={setConfirmLoading}
            setClassData={setClassData}
          />

          <div
            className='class-hero'
            style={{
              backgroundImage: `url(${RetriveImageUrl(classData?.poza)})`,
            }}
          >
            <div className='class-hero-content'>
              <h1 className='class-title'>
                {classData?.anClasa === 'Pregătitoare' ||
                classData?.anClasa === 'I'
                  ? classData?.anClasa + ' ' + classData?.identificator
                  : 'a ' +
                    classData?.anClasa +
                    '-a' +
                    ' ' +
                    classData?.identificator}
              </h1>
              <div className='class-subtitle'>
                {profesori?.find((pf) => pf.id === classData?.diriginte)
                  ?.numeDeFamilie +
                  ' ' +
                  profesori?.find((pf) => pf.id === classData?.diriginte)
                    ?.prenume}
              </div>
            </div>
          </div>

          <Tabs
            className='modern-class-tabs'
            tabBarExtraContent={
              user.type === 'admin' ? (
                <div
                  className='class-settings-btn'
                  onClick={() => setOpen(true)}
                >
                  <SettingOutlined style={{ fontSize: '20px' }} />
                </div>
              ) : null
            }
            size='large'
            onChange={onChange}
            activeKey={tabKey}
            items={[
              {
                label: `Catalog`,
                key: 'Catalog',
                children: (
                  <CatalogComponent
                    classData={classData}
                    setClassData={setClassData}
                    permision={permision}
                  />
                ),
              },
              {
                label: `Orar`,
                key: 'Orar',
                children: (
                  <div className='tab-content-wrapper'>
                    <div className='tab-content-header'>
                      <h2 className='tab-content-title'>Orarul Clasei</h2>
                      <div className='tab-content-description'>
                        Vizualizează și gestionează orarul săptămânal
                      </div>
                    </div>
                    <OrarClasa
                      classData={classData}
                      setClassData={setClassData}
                    />
                  </div>
                ),
              },
              process.env.REACT_APP_RESTRICT !== 'enable' ?? {
                label: `Chat`,
                key: 'CHAT',
                children: (
                  <div className='tab-content-wrapper'>
                    <div className='tab-content-header'>
                      <h2 className='tab-content-title'>Discuții Clasă</h2>
                      <div className='tab-content-description'>
                        Comunicare în timp real cu membrii clasei
                      </div>
                    </div>
                    <Chat classId={classId} classData={classData} />
                  </div>
                ),
              },
              {
                label: `Teme`,
                key: 'Teme',
                children: (
                  <div className='tab-content-wrapper'>
                    <div className='tab-content-header'>
                      <h2 className='tab-content-title'>Teme pentru Acasă</h2>
                      <div className='tab-content-description'>
                        Gestionează temele și sarcinile elevilor
                      </div>
                    </div>
                    <Teme classData={classData} />
                  </div>
                ),
              },
              {
                label: `Lecții`,
                key: 'Lecții',
                children: (
                  <div className='tab-content-wrapper'>
                    <div className='tab-content-header'>
                      <h2 className='tab-content-title'>Lecții și Materii</h2>
                      <div className='tab-content-description'>
                        Planifică și urmărește progresul lecțiilor
                      </div>
                    </div>
                    <Lectii classData={classData} />
                  </div>
                ),
              },
              ...(permision
                ? [
                    {
                      label: `Date Elevi`,
                      key: 'DateElevi',
                      children: (
                        <div className='tab-content-wrapper'>
                          <div className='tab-content-header'>
                            <h2 className='tab-content-title'>
                              Informații Elevi
                            </h2>
                            <div className='tab-content-description'>
                              Gestionează datele personale ale elevilor
                            </div>
                          </div>
                          <DateElevi classData={classData} />
                        </div>
                      ),
                    },
                  ]
                : []),
            ]}
          />
        </>
      )}
    </div>
  );
}

export default withErrorBoundary(Class);

//https://drive.google.com/drive/folders/1SPNrBLKX1yh-ATtZeZLeg1odY_OTrKqB?usp=sharing
